// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RoleFormQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type RoleFormQuery = {
  __typename?: "GraphqlQuery";
  getDatabases: Array<{
    __typename?: "Database";
    id: string;
    displayName: string;
  }>;
  getServers: Array<{ __typename?: "Server"; id: string; name: string }>;
  getServerGroups: Array<{
    __typename?: "ServerGroup";
    id: string;
    name: string;
  }>;
};

export const RoleFormDocument = gql`
  query RoleForm($organizationSlug: ID!) {
    getDatabases(organizationSlug: $organizationSlug) {
      id
      displayName
    }
    getServers(organizationSlug: $organizationSlug) {
      id
      name
    }
    getServerGroups(organizationSlug: $organizationSlug) {
      id
      name
    }
  }
`;

/**
 * __useRoleFormQuery__
 *
 * To run a query within a React component, call `useRoleFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleFormQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useRoleFormQuery(
  baseOptions: Apollo.QueryHookOptions<RoleFormQuery, RoleFormQueryVariables> &
    ({ variables: RoleFormQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RoleFormQuery, RoleFormQueryVariables>(
    RoleFormDocument,
    options,
  );
}
export function useRoleFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RoleFormQuery,
    RoleFormQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RoleFormQuery, RoleFormQueryVariables>(
    RoleFormDocument,
    options,
  );
}
// @ts-ignore
export function useRoleFormSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RoleFormQuery,
    RoleFormQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RoleFormQuery, RoleFormQueryVariables>;
export function useRoleFormSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoleFormQuery, RoleFormQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  RoleFormQuery | undefined,
  RoleFormQueryVariables
>;
export function useRoleFormSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoleFormQuery, RoleFormQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RoleFormQuery, RoleFormQueryVariables>(
    RoleFormDocument,
    options,
  );
}
export type RoleFormQueryHookResult = ReturnType<typeof useRoleFormQuery>;
export type RoleFormLazyQueryHookResult = ReturnType<
  typeof useRoleFormLazyQuery
>;
export type RoleFormSuspenseQueryHookResult = ReturnType<
  typeof useRoleFormSuspenseQuery
>;
export type RoleFormQueryResult = Apollo.QueryResult<
  RoleFormQuery,
  RoleFormQueryVariables
>;
